export default "/images/vendor/flag-icon-css/flags/1x1/nf.svg?7c3216dcabd2a393fa48df68238d1667";